import { PageSection } from '@traceio-org/ui';
import { AuditLog } from '../../components/AuditLog';
import { useOrganizationScope, useSupportAccessHint } from './scope';

/** Audit (/organizations/:id/audit): the organization's audit log, with its filters and changes. */
export function AuditTab() {
  const { organization } = useOrganizationScope();
  const hint = useSupportAccessHint();
  return (
    <PageSection
      title="Audit log"
      description={`Every change to ${organization.displayName} and every staff read of it, newest first, with the reason and the fields that changed.`}
    >
      <AuditLog organizationId={organization.id} supportAccess={hint} />
    </PageSection>
  );
}
